import React from 'react';
import { encode } from 'base-64';
import { Content } from './styles'; // styled component where we keep all the content styles

import { withRfqWidget } from '../RfqWidget';
import { withNatoms } from '../NatomsComponent';

var createWebPUrl = function createWebPUrl(src, w, h) {
  src = "http://www.business.com".concat(src);
  var resizerHost = 'https://img.business.com'; // This regex plucks the last part of the src url
  // Example src: /images/content/5af/4720392a3a453198b456f/1430-883-
  // Regex would find: 1430-883-

  var cmsWidth = src.match(/([^/]+)\/?$/g)[0].split('-')[0];

  if (isNaN(cmsWidth)) {
    // force png at current WxH
    return "".concat(resizerHost, "/custom/of=png").concat(w ? ",dw=".concat(w) : '').concat(h ? ",dh=".concat(h) : '', "/").concat(encode(src));
  } // Use cms' defined width to generate dyanmic image (serves webp if supported)


  return "".concat(resizerHost, "/w/").concat(cmsWidth, "/").concat(encode(src));
};

var replaceFunctionDictionary = {
  src: function src(_src) {
    return createWebPUrl(_src);
  },
  srcset: function srcset() {
    var _srcset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return _srcset.split(', ').map(function (src) {
      return createWebPUrl(src);
    }).join(', ');
  }
};
/**
 * This component just outputs dangerously set inner html and wrapped in a styled component with content styling
 *
 * Used for Article, Category and Review Templates
 */

function ContentContainer(_ref) {
  var content = _ref.content;
  var newContent = content.replace(/(srcset|src)="(\/images(?:[^"]*))"/g, function (matched, attribute, value) {
    var newValue = replaceFunctionDictionary[attribute](value);
    return "".concat(attribute, "=\"").concat(newValue, "\"");
  });
  return /*#__PURE__*/React.createElement(Content, {
    dangerouslySetInnerHTML: {
      __html: newContent
    }
  });
}

export default withRfqWidget(withNatoms(ContentContainer));